import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import { colors } from '@mui/material';
import { BackgroundColor, BorderColor, OpacityColor, PrimaryColor } from 'styles/Global/colorSemantic';
import MobileBasicButton from 'components/Buttons/MobileBasicButton';
import { CertificationList } from './Components/CertificationList';
import { Body2Bold, Body2SemiBold, Body3SemiBold, Body4Medium, Title2SemiBold } from 'styles/Global/typography';
import Coin from '../../../../assets/SungnamIcons/Img/coin.png';
import { useGovernmentHeaderStore } from 'store/useGovernmentHeaderStore';
import { useLocation, useNavigate } from 'react-router-dom';
import { connectMindPaths, preciousChildPaths } from 'constants/path';
import { handleIframe, handleMessage, handlePayment } from 'utils/payment';
import usePurchaseCounselingMutation from 'api/Mutations/SMS/usePurchaseCounselingMutation';
import { useLoadingStore } from 'store/useLoadingStore';
import MobileLeaveModal from 'components/Modal/MobileLeaveModal';
import useToggle from 'hooks/CustomHooks/useToggle';

const PurchaseCounselServicePage = () => {
    const navigate = useNavigate();
    const { setHeaderText } = useGovernmentHeaderStore();
    const { mutate } = usePurchaseCounselingMutation();
    const { loading, setLoading } = useLoadingStore();
    const [isShowFailModal, setIsShowFailModal] = useToggle();
    const { state } = useLocation();
    const diagnosisInfo = state?.diagnosisInfo;
    const voucher = state?.voucher;
    const token = state?.token;

    const handleConsultationReservation = async (mchtTrdNo: string, paymentId: string) => {
        const rqData = {
            diagnosisId: diagnosisInfo._id,
            paymentId: paymentId,
            token: token,
        };
        mutate(rqData, {
            onSuccess: () => {
                // navigate(preciousChildPaths.counselReservation, { replace: true, state: { diagnosisInfo, voucher, token } });
            },
            onError: () => {},
        });
    };

    const qualifications = ['상담심리 석사 또는 박사', '아동심리상담 1급 또는 2급', '청소년심리상담 1급 또는 2급', '가족심리상담 등 1급 또는 2급'];

    useEffect(() => {
        setHeaderText('심층상담 신청');
    }, []);

    const [form, setForm] = useState({
        productName: '심층심리상담',
        paymentAmount: 50000,
        serviceName: '성남시 심층심리상담',
        serviceEName: 'SUNGNAM-PSY-CONSULTATION',
        serviceType: '0',
        customerName: diagnosisInfo?.patientName ?? '',
        customerEmail: '',
        customerMobile: diagnosisInfo?.patientMobile ?? '',
        nextUrl: `${window.location.origin}${connectMindPaths.sungnamPurchaseCounselService}`,
        notiUrl: `${window.location.origin}${connectMindPaths.counselReservation}`,
        cancUrl: `${window.location.origin}${connectMindPaths.sungnamPurchaseCounselService}`,
        method: 'card',
        company: 'sungnam',
    });

    // URL 파라미터로 결제 취소 감지 및 처리
    useEffect(() => {
        handleIframe();
        const messageHandler = (event: MessageEvent) => handleMessage(token, diagnosisInfo, voucher, event, navigate);
        window.addEventListener('message', messageHandler);

        return () => window.removeEventListener('message', messageHandler);
    }, [navigate]);

    useEffect(() => {
        const off = () => setLoading(false);
        window.addEventListener('SETTLE_IFRAME_CLOSED', off);
        return () => window.removeEventListener('SETTLE_IFRAME_CLOSED', off);
    }, [setLoading]);

    // jQuery 및 헥토 결제 스크립트 동적 로드
    useEffect(() => {
        const jqueryScript = document.createElement('script');
        jqueryScript.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
        jqueryScript.async = false;
        document.body.appendChild(jqueryScript);
        jqueryScript.onload = () => {
            const settleScript = document.createElement('script');
            settleScript.src = 'https://npg.settlebank.co.kr/resources/js/v1/SettlePG_v1.2.js';
            settleScript.async = false;
            document.body.appendChild(settleScript);
        };

        return () => {
            const settleScript = document.querySelector('script[src*="SettlePG_v1.2.js"]');
            if (settleScript) document.body.removeChild(settleScript);
            document.body.removeChild(jqueryScript);
        };
    }, []);

    return (
        <Container>
            {isShowFailModal && (
                <MobileLeaveModal
                    title='결제 실패'
                    content={`결제가 정상적으로 처리되지 않았어요.\n\n확인 후 다시 시도해주세요.`}
                    firstButton='확인'
                    firstButtonType='fill'
                    setIsLeaveModal={setIsShowFailModal}
                />
            )}
            <TitleContainer>
                <Title2SemiBold>전문가의 조언이 필요하신가요?</Title2SemiBold>
                <Body4Medium>10년 이상 경력의 전문 상담사가 검사 결과를 바탕으로 1:1 심층 유선 상담을 제공합니다.</Body4Medium>
            </TitleContainer>
            <ContentsContainer>
                <Card $padding='20px 20px 20px 16px' $backgroundColor={OpacityColor.color_opacity_primary_light_8}>
                    <PriceRow>
                        <IconTitleContainer>
                            <ImgWrapper src={Coin} alt='agreePage_Family_Image' />
                            <Body2SemiBold>전화 상담 20분</Body2SemiBold>
                        </IconTitleContainer>
                        <Body2Bold $color={PrimaryColor.color_primary_normal}>50,000원</Body2Bold>
                    </PriceRow>
                </Card>
                <Card $padding='20px 16px' $gap='12px' $backgroundColor={BackgroundColor.color_background_light} $borderColor={BorderColor.color_border_weak} flexDirection='column'>
                    <div style={{ padding: '0px 4px' }}>
                        <Body3SemiBold>상담사 학력 및 자격</Body3SemiBold>
                    </div>
                    <CertificationList items={qualifications} />
                </Card>
                <MobileBasicButton
                    $width='100%'
                    $height='52px'
                    $type='fill'
                    onClick={() => {
                        handlePayment(setLoading, form, navigate, handleConsultationReservation);
                    }}
                >
                    결제하고 상담받기
                </MobileBasicButton>
            </ContentsContainer>
        </Container>
    );
};

export default PurchaseCounselServicePage;

const Container = styled.div`
    padding: 0px 16px;
`;

const IconTitleContainer = styled.div`
    display: flex;
    gap: 6px;
`;

const ImgWrapper = styled.img`
    width: 24px;
    height: 24px;
`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px 0px 20px 0px;
`;

const ContentsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 8px;
`;

const Card = styled.div<{ $backgroundColor?: string; $borderColor?: string; $padding?: string; $gap?: string; flexDirection?: string }>`
    display: flex;
    flex-direction: ${(props) => props.flexDirection || 'column'};
    background-color: ${(props) => props.$backgroundColor ?? colors.common.white};
    gap: ${(props) => props.$gap || '0px'};
    border: ${(props) => `1px solid ${props.$borderColor ?? OpacityColor.color_opacity_primary_light_8}`};
    padding: ${(props) => props.$padding ?? '20px'};
    border-radius: 12px;
`;

const PriceRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
